export const UserProfileCardTestIds = {
  profileBackdrop: 'profile_backdrop',
  profileCard: 'profile_card',
  profileHeader: 'profile_header',
  buttonBack: 'button_back',
  profileTitle: 'profile_title',
  userInfoRow: 'user_info_row',
  avatarContainer: 'avatar_container',
  userName: 'user_name',
  userStatus: 'user_status',
  statusText: 'status_text',
  statusIcon: 'status_icon',
  contactInfo: 'contact_info',
  timAddress: 'tim_address',
  vzdAddress: 'vzd_address',
  additionalContact: 'additional_contact',
  contactPerson: 'contact_person',
  contactAddress: 'contact_address',
  locationIcon: 'location_icon',
  addressText: 'address_text',
  buttonCopyAddress: 'button_copy_address',
  commonRoomsSection: 'common_rooms_section',
  cardCommonroom: 'card_commonroom',
  commonroomTimestamp: 'commonroom_timestamp',
  commonroomMessage: 'commonroom_message',
  paginatorCommonrooms: 'paginator_commonrooms',
  messageSection: 'message_section',
  messageInputContainer: 'message_input_container',
  messageTextarea: 'message_textarea',
  buttonSendMessage: 'button_send_message',
  buttonWriteMessage: 'button_write_message',
  kvnrText: 'kvnr_text',
  buttonCopyKvnr: 'button_copy_kvnr',
  copyIcon: 'copy_icon'
} as const;
